{
  "de": {
    "task_assignment": {
      "actions": {
        "confirm": "Als erledigt markieren",
        "create": "Aufgabe",
        "reopen": "Erneut öffnen",
        "update": "Aufgabe bearbeiten"
      },
      "assignee_types": {
        "customer": "Kunde",
        "employee": "Mitarbeiter",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Verantwortlich",
        "assignees": "Verantwortliche",
        "created_at": "Erstellt",
        "due_date": "Frist",
        "project": "Projekt",
        "published": "Veröffentlicht",
        "status": "Status",
        "task": "Aufgabe",
        "unit": "Einheit"
      },
      "labels": {
        "add_assignee": "Verantwortliche Person hinzufügen …",
        "add_customers": "Kunden hinzufügen",
        "already_assigned": "Diese Aufgabe wurde dieser Einheit bereits hinzugefügt.",
        "completed": "Erledigt",
        "confirm_message": "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
        "customers": "Kunden",
        "my_tasks": "Meine Aufgaben",
        "no_assignees": "Noch keine Verantwortlichen.",
        "no_assignments": "Noch keine Aufgaben.",
        "no_assignments_task": "Noch keine Zuweisungen für diese Aufgabe.",
        "no_assignments_unit": "Noch keine Aufgaben für diese Einheit.",
        "publish_all": "Alle veröffentlichen",
        "publish_customers": "Für die Kunden jeder Einheit veröffentlichen",
        "published": "Veröffentlicht",
        "required": "Dieses Feld ist erforderlich",
        "select_task": "Aufgabe auswählen",
        "upload_hint": "Laden Sie die angeforderten Dokumente hoch, um diese Aufgabe zu erledigen.",
        "uploaded_documents": "Hochgeladene Dokumente"
      },
      "statuses": {
        "completed": "Erledigt",
        "draft": "Entwurf",
        "pending": "Ausstehend"
      },
      "toasts": {
        "completed": "Aufgabe erledigt",
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "uncompleted": "Aufgabe wieder geöffnet",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
